import com.github.chosamuel.kishibe.application.*
import com.github.chosamuel.kishibe.application.renderer.Color
import com.github.chosamuel.kishibe.color.cosineColor
import com.github.chosamuel.kishibe.graphics.Mesh
import com.github.chosamuel.kishibe.math.Vector2
import com.github.chosamuel.kishibe.math.map
import com.github.chosamuel.kishibe.noise.simplex
import org.khronos.webgl.WebGLRenderingContext
import kotlin.math.PI
import kotlin.math.cos
import kotlin.math.sin

var m = Vector2(0.0,0.0)
fun Application.drawSpectralEye() {
    val mt = Vector2(
        mouseX / getWidth(),
        mouseY/ getHeight()
    )
    m += mt.minus(m).times(0.01)

    val c = Mesh(gl,this)
    val scale = 0.409
    val r  = when {
        getWidth() > getHeight() -> getHeight() * scale
        getWidth() < getHeight() -> getWidth() * scale
        else -> getWidth() * scale
    }
    val resolution = 360
    val center = Vector2(getWidth()*.5,getHeight()*.5)
    val pos = Vector2(
        map(
            -1.0,
            1.0,
            getWidth() * .5 - r,
            getWidth() * .5 + r,
            simplex(69.0,frameCount*0.005,1.0,0.0)
        ),
        map(
            -1.0,
            1.0,
            getHeight() * .5 - r,
            getWidth() * .5 + r,
            simplex(42.0,frameCount*0.005,0.0,0.0)
        )
    )
    val timeMod = 0.005
    var col = cosineColor(
        frameCount*timeMod
    )
    c.addVertex(pos)
    c.addColor(Color(col[0],col[1],col[2]))
    c.addIndex(0)
    repeat(resolution+1){ i->
        val step = (2* PI)  / (resolution * 1.0)
        val x = cos(step*i) * r + center.x
        val y = sin(step*i) * r + center.y
        val pt = Vector2(x,y )
        val theta = (i / (resolution+1)* 1.0) * 2 * PI
        val dn = 0.0005
        col = cosineColor (
            simplex(
                x * dn * cos(theta*frameCount*0.01),
                y * dn * sin(theta*frameCount*0.01),
                frameCount * 0.001,
                1.0
            ) * 7.0 + frameCount * (timeMod * m.x)
        )
        c.addVertex(pt)
        c.addColor(Color(col[0],col[1],col[2]))
        c.addIndex((i+1).toShort())
    }
    c.draw(WebGLRenderingContext.TRIANGLE_FAN)
}